import { VolumeGrain } from '../models/volume-dashboard.model';
import { localizeCalendarDate, parseCalendarDate } from './calendar-date';

export interface ChartBucketLabel {
  axis: string;
  tooltip: string;
}

export function formatChartBucketLabel(
  start: string,
  end: string | undefined,
  grain: VolumeGrain,
  language: string
): ChartBucketLabel {
  if (grain === 'month') {
    const label = localizeCalendarDate(
      start,
      { month: 'short', year: 'numeric' },
      language
    );
    return { axis: label, tooltip: label };
  }

  if (grain === 'day') {
    return {
      axis: localizeCalendarDate(start, { day: 'numeric' }, language),
      tooltip: localizeCalendarDate(
        start,
        { month: 'long', day: 'numeric', year: 'numeric' },
        language
      ),
    };
  }

  const axis = localizeCalendarDate(
    start,
    { month: 'short', day: 'numeric' },
    language
  );
  if (!end || end === start) return { axis, tooltip: axis };

  const sameMonth =
    parseCalendarDate(start).getMonth() === parseCalendarDate(end).getMonth();
  const endLabel = localizeCalendarDate(
    end,
    sameMonth ? { day: 'numeric' } : { month: 'short', day: 'numeric' },
    language
  );
  return { axis, tooltip: `${axis} – ${endLabel}` };
}
